import React from "react";
//import { Desabilitar } from "../../components/Mouse";

function Performance() {
  return (
    <>
      
      <div className="home">
        <iframe
          title="Performance"
          class="video"
          widht="100%"
          height="100%"
          src="https://app.powerbi.com/reportEmbed?reportId=ca467558-03f3-44ed-ac02-6a7e9682a4ad&autoAuth=true&ctid=f88c7305-11d1-4b34-a8a0-da6536019e31"
          marginheight="0"
          marginwidth="0"
          scrolling="0"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
}

export default Performance;
